import { color, xScreen } from "@stoneage/XDL/Utilities";
import { xSwiperShadow, xSwiperStyle } from "@stoneage/App/Components/XngCarousel/styles/carousel.styles";
import { css } from "styled-components";
import { IconWrapper } from "@insite/mobius/Icon";
import { SwiperStyle } from "@stoneage/App/Components/XngCarousel";

export const stoneageStyles: SwiperStyle = {
    container: {
        css: css`
            ${xSwiperStyle}

            /* Vertical layout adjustments */
            ${({ direction, height }: any) =>
                direction === "vertical" &&
                css`
                    &:not(:has(.swiper-scrollbar-lock)) {
                        .swiper-wrapper {
                            padding-right: 14px;
                        }
                        .arrow-button {
                            width: calc(100% - 14px);
                        }
                    }
                    .swiper-wrapper {
                        height: 100% !important;
                        max-height: ${height ? `${height}px` : "100%"};
                    }
                    .swiper-slide,
                    .swiper-slide > div {
                        width: 100%;
                    }
                `}

            .swiper-wrapper {
                box-sizing: border-box;
            }

            .xng-pagination-container {
                display: flex;
                flex-direction: column;
                margin-top: 16px;
                gap: 24px;

                .xng-pagination-inner-container {
                    position: relative;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    gap: 0;
                    &:empty {
                        display: none;
                    }
                }

                & > div,
                & > button {
                    margin: 0;
                }
            }

            .xng-pagination-container > .swiper-scrollbar.swiper-scrollbar-horizontal {
                height: 4px;
                width: 100%;
                position: relative;
                top: unset;
                right: unset;
                bottom: unset;
                left: unset;
                transform: initial;
                display: flex;
                align-items: center;
                background: transparent;
                border-radius: 4px;

                & > .swiper-scrollbar-drag {
                    background: ${color("common.black", 0.5)};
                    border-radius: 100px;
                    height: 4px;
                }

                &.swiper-scrollbar-lock {
                    display: none;
                }
            }

            .swiper-horizontal > .xng-pagination-container > .xng-pagination-inner-container {
                min-height: ${({ arrowsBelowSlides }: any) => (arrowsBelowSlides ? "14px" : "4px")};
                display: flex;
                justify-content: center;
                gap: 16px;
                &:empty {
                    display: none;
                }
            }

            ${({ slideMaxWidth }: any) =>
                slideMaxWidth &&
                css`
                    .swiper-slide {
                        max-width: ${slideMaxWidth};
                    }
                `}

            ${({ isAutoWidth }: any) =>
                isAutoWidth &&
                css`
                    .swiper-slide {
                        width: auto;
                    }
                `}

            .swiper-pagination {
                position: relative;
                text-align: center;
                display: flex;
                align-items: center;
                justify-content: start;
                flex-wrap: wrap;
                gap: 4px;
                padding-block: 0;

                &.swiper-pagination-lock {
                    display: none;
                }

                .swiper-pagination-bullet {
                    width: 8px;
                    height: 8px;
                    background: transparent;
                    border: 1px solid ${color("common.ui6")};
                    opacity: 1;
                    margin: 0 !important;

                    &:hover:not(.swiper-pagination-bullet-active) {
                        background: ${color("primary")};
                        border-color: ${color("primary")};
                    }

                    &.swiper-pagination-bullet-active {
                        background: ${color("common.ui7")};
                        border-color: ${color("common.ui7")};
                        color: ${color("common.white")};
                    }
                }
            }

            ${xScreen("gte", "sm")} {
                ${xSwiperShadow}
            }
        `,
    },
};
